import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map, toLower } from "lodash";
import Grid from "@material-ui/core/Grid";

import RecurrenceEnds from "./RecurrenceEnds";
import RecurrenceEvery from "./RecurrenceEvery";
import { getRecurrenceSentence } from "../../../utils/scheduler";
import CustomSelect from "../../Common/CustomSelect";

const RecurrenceWeekly = (props) => {
  const { classes, formValues, changeParam } = props;

  return (
    <>
      <RecurrenceEvery
        classes={classes}
        formValues={formValues}
        changeParam={changeParam}
      />
      <Grid item className={classes.row}>
        <Grid container alignItems="center">
          <Grid item className={classes.label} style={{ paddingBottom: 0 }}>
            {I18n.get("scheduler_on")}
          </Grid>
          <Grid item xs>
            <Grid container alignItems="center">
              <Grid item>{toLower(I18n.get("common_day"))}</Grid>
              <Grid item style={{ width: "80px", padding: "0px 10px" }}>
                <CustomSelect
                  name="on"
                  value={get(formValues, ["recurrence", "on"])}
                  onChange={(e) => changeParam("on", null, e.target.value)}
                  options={map(
                    map(new Array(31), (item, index) => index + 1),
                    (item) => ({
                      id: item,
                      name: item,
                    })
                  )}
                  noSort
                />
              </Grid>
              <Grid item>{I18n.get("scheduler_ofTheMonth")}</Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <RecurrenceEnds
        classes={classes}
        formValues={formValues}
        changeParam={changeParam}
      />
      <Grid item className="text-54" style={{ fontSize: "0.857em" }}>
        {getRecurrenceSentence("monthly", formValues)}
      </Grid>
    </>
  );
};

export default RecurrenceWeekly;
